import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import { QuestionAPI, JobsV3API } from './API';
import env from '../misc/env';
import { retryOnNetworkFailure, extractMessageFromError } from '../utils/errorUtil';
import Question from './Question';

/**
 * Question store.
 */
var QuestionStore = /*#__PURE__*/function (_Store) {
  function QuestionStore() {
    var _this;
    _classCallCheck(this, QuestionStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, QuestionStore, [].concat(args));
    _this.legacyApi = new QuestionAPI({
      baseURL: env.JOB_API,
      getToken: _this.rootStore.authStore.getToken,
      supported_engine_version: env.SUPPORTED_ENGINE_VERSION
    });
    _this.api = new JobsV3API({
      baseURL: env.WORK_DOTNET_API,
      token$: _this.rootStore.authStore.token$
    }, _this.rootStore.workRealtime$);
    _this.questions = _this.collection({
      model: Question,
      getDataId: function getDataId(data) {
        return "".concat(data.jobId, "/").concat(data.id);
      },
      getModelId: function getModelId(model) {
        return "".concat(model.jobId, "/").concat(model.id);
      }
    });
    _this.questionsForJob = function (jobId) {
      return _this.questions.filter(function (q) {
        return q.jobId === jobId;
      });
    };
    return _this;
  }
  _inherits(QuestionStore, _Store);
  return _createClass(QuestionStore, [{
    key: "getQuestions",
    value: // TODO: Remove once feature toggle is removed
    function () {
      var _getQuestions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", retryOnNetworkFailure(function () {
                return _this2.legacyApi.getQuestions(payload);
              }).doneRetrying(function (e) {
                return _this2.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getQuestions(_x) {
        return _getQuestions.apply(this, arguments);
      }
      return getQuestions;
    }()
    /**
     * Fetch job questions with answers.
     *
     * @param {string} jobId.
     * @param {Object[]} questions. Pre calculates the questionnaire from unsaved
     * question/answers.
     * @param {string} questions[].id The unique question identifier.
     * @param {string} questions[].type The question type.
     * @param {string} questions[].multi Determines if the select question type allows
     * for multiple choices.
     * @param {any} questions[].answer Its value will depend upon the question's type.
     */
  }, {
    key: "fetchQuestions",
    value: (function () {
      var _fetchQuestions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(jobId, questions) {
        var _this3 = this;
        var payload, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              payload = (questions === null || questions === void 0 ? void 0 : questions.filter(function (question) {
                return question.isAnswered;
              })) || [];
              _context2.next = 3;
              return this.api.listQuestions(jobId, payload).catch(function (e) {
                _this3.rootStore.flashMessageStore.create({
                  message: extractMessageFromError(e),
                  type: 'error'
                });
                throw e;
              });
            case 3:
              response = _context2.sent;
              this.questions.clear();
              this.questions.set(response.questions.map(function (dto) {
                return _objectSpread({
                  jobId: jobId
                }, dto);
              }));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchQuestions(_x2, _x3) {
        return _fetchQuestions.apply(this, arguments);
      }
      return fetchQuestions;
    }())
  }]);
}(Store);
export { QuestionStore as default };
//# sourceMappingURL=QuestionStore.js.map
